<div class="flxClmn f-1-0 vSpace2 bs-enabled" style="overflow: auto;">
	<!--loader-->
	<div class="f-1-0 flex-column centralize" *ngIf="_.isUndefined(isThisFeatureSupported)">
		<loader height="100" width="100" style="opacity: 0.8;"></loader>
	</div>

	<ng-container *ngIf="isThisFeatureSupported">
		<!--main content area-->
		<div class="flxRow animated fadeIn" style="flex: 1 0; overflow: auto;" *ngIf="campaigns?.length">
			<!--list of campaigns (left side)-->
			<div class="flxClmn" style="flex: 0.6 0; margin: 0 7px; padding: 5px; min-width: 450px; min-height: 350px; background: linear-gradient(#163f5d1a, transparent, #a0a0a02e) , linear-gradient(74deg, #d3f1ff6b , transparent 51%, transparent);">
				<div class="flxClmn" style="flex: 1 0; overflow: auto;" >
					<div class="w100 flxRow-between" style="background: #677184; padding: calc(3px + 0.4vw); align-items: center; z-index: 1; min-height: 42px;">
						<btn-c style="background: white;"
							   variant="outlined" endIcon="far fa-plus"
							   (action)="newCampaignWizard();">
							Create Campaign
						</btn-c>
						<div class="flxRow hSpace1" style="align-items: center;">
							<!--Search-->
							<search-box [(model)]="searchCampaignTxt"
										(modelChange)="triggerSearch()"
										placeholder="Search campaign"
										style="width: 30%; min-width: 200px;">
							</search-box>
						</div>
					</div>

					<trustifi-table-c
						class="trustifi-table" style="flex: 1 0; z-index: 5; background: white;"
						[list]="campaigns"
						[headers]="[
							{text: 'Name', sortKey: 'created'},
						]"
						[cellsPrototype]="[
							{html: 'nameCell'},
						]"
						[bulkActions] = "{
							enable: true,
							selectBulkActionCb:	selectMultipleCampaignAction,
							initBulkActionsFunction: showBulkCampaignsActions,
							showInRed: {enable: true, terms: ['Delete']}
						}"
						[subRowOptions]="{
							recursionKey: 'campaigns',
							allowActions: true
						}"
						[cellActions]="{
							enable: true,
							selectItemActionCb:	selectCampaignAction,
							initActionsFunction: showCampaignActions,
							showInRed: {enable: true, terms: ['Delete']}
						}"
						(onAnyItemSelected)="!$event.isItemSelectCheckboxClicked && setCurrentCampaign($event.item)"
						(searchFunction)="searchCampaign($event.searchTerm, $event.activeFilters)"
						[options]="{
							loadingTableFlag: getCampaignsInProcess,
							soloSelected: true,
							hideContentAboveTable: true,
							itemsNameSingular: 'campaign',
							defaultSortKey: '-created'
						}"
					>
						<!--log action cells-->
						<ng-template #customCells let-item let-cellId="cellId">
							<span *ngIf="cellId === 'nameCell'">
								<div class="flxRow hSpace05" style="align-items: center; cursor: pointer;"
									 *ngIf="!item.isCompanyTitleRecord"
									 (click)="toggleExpandItem(item, $event);"
									 [ngStyle]="{'padding-left' : item.depthLevel ? 15 + item.depthLevel * 15 + 'px' : ''}">
									<i class="far fa-chevron-right" style="color: royalblue; transition: transform 0.15s ease-out; padding: 5px; padding-left: 0;"
									   *ngIf="item.campaigns?.length"
									   [ngStyle]="{'transform' : item.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}"></i>
									<div class="flxClmn gap-1">
										<span>{{item.name}}</span>
										<span *ngIf="item.created" style="font-size: 10px;">{{item.created | date: 'MM/dd/yyyy HH:mm'}}</span>
									</div>
								</div>
							</span>
						</ng-template>
						<!---->
					</trustifi-table-c>
				</div>
			</div>

			<!--Email display area (right side)-->
			<div class="vertical-separator" style="border-color: #e3e4e4; border-left: none;"></div>
			<div class="flxClmn" style="flex: 2 0; align-items: center; margin-left: 20px; position: relative; overflow: auto;"
				 [ngStyle]="{'background': currentCampaign ? 'transparent' : '#f7f7f7'} ">
				<!--loading overlay-->
				<div class="flxClmn-center animated fadeIn" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5; background: rgba(255,255,255,0.6); align-items: center;"
					 *ngIf="getCampaignDataInProcess">
					<div class="loading-spinner" style="position: relative; top: 0; left: 0; opacity: 1;"></div>
				</div>
				<!----->
				<div class="flxClmn-center vSpace2 w100" style="flex:1 0; overflow: auto;" *ngIf="currentCampaign">
					<!--tabs-->
					<div class="simple-tab-row w100 flxRow">
						<ng-container *ngFor="let tab of dic.CONSTANTS.threatSimulationCampaignTabs | keyvalue: gs.returnZero">
							<div class="tab-header"
								 *ngIf="!(currentCampaign.campaigns && tab.value === dic.CONSTANTS.threatSimulationCampaignTabs.emailDetails)
              								&& (tab.value !== dic.CONSTANTS.threatSimulationCampaignTabs.configuration || currentCampaign.configuration)"
								 [ngClass]="{'chosen' : activeCampaignTab === tab.value}"
								 (click)="activeCampaignTab = tab.value;">
								<span class="hvr-opacity">{{tab.value}}</span>
							</div>
						</ng-container>
					</div>

					<div class="flxClmn" style="flex: 1 0; overflow: auto;">
						<threat-simulation-campaign-details-component
							*ngIf="activeCampaignTab === dic.CONSTANTS.threatSimulationCampaignTabs.emailDetails"
							  [currentCampaign]="currentCampaign"
							  (deleteCampaign)="openDeleteCampaignPopup([currentCampaign]);"
							  class="flxClmn f-1-0" style="overflow: auto;" ></threat-simulation-campaign-details-component>

						<threat-simulation-campaign-recipients-summary-component
							*ngIf="activeCampaignTab === dic.CONSTANTS.threatSimulationCampaignTabs.recipientEngagement"
						  [currentCampaign]="currentCampaign"
						  class="flxClmn f-1-0" style="overflow: auto;" ></threat-simulation-campaign-recipients-summary-component>

						<threat-simulation-campaign-summary-component
							*ngIf="activeCampaignTab === dic.CONSTANTS.threatSimulationCampaignTabs.summary"
						  [currentCampaign]="currentCampaign"
						  class="flxClmn f-1-0" style="overflow: auto;" ></threat-simulation-campaign-summary-component>

						<threat-simulation-campaign-configuration-component
							*ngIf="activeCampaignTab === dic.CONSTANTS.threatSimulationCampaignTabs.configuration"
						  [currentCampaign]="currentCampaign" [configuration]="currentCampaign.configuration"
						  class="flxClmn f-1-0" style="overflow: auto;" ></threat-simulation-campaign-configuration-component>
					</div>
				</div>

				<div *ngIf="!currentCampaign && !getCampaignDataInProcess" class="flxClmn-center"
					 style="align-items: center; flex: 1 0;">
					<i class="far hvr-opacity fa-envelope-open-text" style="font-size: 4vw;  opacity: 0.1;"></i>
				</div>
			</div>
		</div>

		<!--Create First Campaign screen-->
		<div class="f-1-0 flex-column centralize" style="background: linear-gradient(45deg, #ffffff99 , #ffffff00,  #ffffff), linear-gradient(-45deg, #ffffff , #ffffff00,  #ffffff), linear-gradient(#163f5d0d, transparent, #a0a0a02e) , linear-gradient(74deg, #d3f1ff , #ffffff00 51%, transparent);"
			 *ngIf="!campaigns?.length">
			<div class="flex-column centralize bg-white create-new-box gap-3" style="width: 90vh; height: 60vh; box-shadow: 0 2px 16px lightgrey;">
				<img src="images/newTsCampaign.png" style="margin-top: -8vh; width: 45vh; margin-bottom: 5vh;">
				<ng-container *ngIf="!threatSimulationConfig?.template_fields?.company">
					<span style="font-size: clamp(14px, 3vh, 25px);">Getting started!</span>
					<span style="font-size: clamp(13px, 2vh, 20px); margin-bottom: 2vh; max-width: 70%;">Before creating your first campaign, you need to set your <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.configuration, dic.CONSTANTS.threatSimulationConfigPageTabs.customization]">Template Parameters</a> and configure <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.configuration, dic.CONSTANTS.threatSimulationConfigPageTabs.configuration]">Settings</a> on your email server</span>
				</ng-container>
				<ng-container *ngIf="threatSimulationConfig?.template_fields?.company">
					<span style="font-size: clamp(14px, 3vh, 25px); margin-bottom: 2vh;">Create your first {{isTrainingCampaignsTab ? 'Training' : 'Threat Simulation'}} Campaign</span>
					<btn-c class="popup-action-btn"
						   endIcon="far fa-plus"
						   (action)="newCampaignWizard();">
						Create Campaign
					</btn-c>
				</ng-container>
			</div>
		</div>
		<!---->
	</ng-container>

	<!--feature not supported-->
	<threat-simulation-not-supported style="display: contents;" *ngIf="isThisFeatureSupported === false"></threat-simulation-not-supported>
	<!---->

	<threat-simulation-campaign-wizard
		*ngIf="showNewCampaignWizard"
		[allCampaignGroups]="_.filter(campaigns, 'campaigns')"
		[verifiedDomains]="verifiedDomains"
		[relaunchCampaign]="campaignForRelaunch ? campaignForRelaunch : null"
		(cancelCb)="showNewCampaignWizard = false;"
		(doneCb)="showNewCampaignWizard = false; getThreatSimulationCampaigns($event.newCampaignId);"
	></threat-simulation-campaign-wizard>

	<!--Assign item to admin popup-->
	<popup-c class="overflownV" *ngIf="updateCampaignGroupPopup?.show"
			 head="Assign Campaign to Group"
			 (closeCb)="updateCampaignGroupPopup = null;"
			 (confirmCb)="updateCampaignGroupPopup?.doneCb()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: updateCampaignGroupPopup.loading}}" size="dynamic">
		<div class="flxClmn vSpace1" style="overflow: visible;">
			<span>Choose which group the selected campaign should be added to</span>
			<span>Campaign: <b>{{updateCampaignGroupPopup.campaignToInsert.name}}</b></span>
			<br/>
			<div class="flxClmn vSpace1">
				<div class="flex-row align-items-center w100">
					<label class="radio-container" style="flex-basis: 130px; margin: 0;">
						Existing group:
						<input type="radio" name="isNewGroupInput" [value]="false"
							   [disabled]="!updateCampaignGroupPopup.groups.length"
							   [(ngModel)]="updateCampaignGroupPopup.isNewGroup"
							   [checked]="updateCampaignGroupPopup.isNewGroup === false">
						<span class="checkmark"></span>
					</label>
					<span class="text-muted" *ngIf="!updateCampaignGroupPopup.groups.length">No groups</span>
					<app-dropdown-c style="width: 200px;"
									[text]="updateCampaignGroupPopup.selectedGroup?.name || ''"
									*ngIf="updateCampaignGroupPopup.groups.length"
									[items]="updateCampaignGroupPopup.groups"
									[isDisabled]="updateCampaignGroupPopup.isNewGroup"
									itemDisplayKey="name" [enableSearch]="true"
									[error]="updateCampaignGroupPopup.error && updateCampaignGroupPopup.isNewGroup === false"
									(onItemClicked)="updateCampaignGroupPopup.selectedGroup = $event.item; updateCampaignGroupPopup.error = false;">
					</app-dropdown-c>
				</div>

				<div class="flex-row align-items-center w100">
					<label class="radio-container" style="margin-bottom: 0; flex-basis: 130px;">
						New group:
						<input type="radio" name="isNewGroupInput" [value]="true"
							   [(ngModel)]="updateCampaignGroupPopup.isNewGroup"
							   [checked]="updateCampaignGroupPopup.isNewGroup === true">
						<span class="checkmark"></span>
					</label>
					<div class="flex-row align-items-center gap-2 f-1-0">
						<input type="text" style="width: 200px;"
							   (keyup)="updateCampaignGroupPopup.error = false;"
							   [ngClass]="{'disabled' : !updateCampaignGroupPopup.isNewGroup, 'validation-error' : updateCampaignGroupPopup.error && updateCampaignGroupPopup.isNewGroup === true}"
							   [(ngModel)]="updateCampaignGroupPopup.newGroupName">
					</div>
				</div>
			</div>
		</div>
	</popup-c>

	<!--Add recipients popup-->
	<popup-c class="bs-enabled" *ngIf="addCampaignRecipientsPopup?.show"
			 head="Add Recipients to Campaign" size="large"
			 subTitle="Select the recipients you want to add to Threat Simulation campaign"
			 (closeCb)="addCampaignRecipientsPopup = null;"
			 (confirmCb)="addRecipientsToCampaignExecute();"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: addCampaignRecipientsPopup.executeInProcess, disabled: addCampaignRecipientsPopup.loading}}">
		<div class="flex-column overflow-auto f-1-0 gap-2 p-3 pt-4">
			<div class="flex-column f-1-0 gap-3 overflow-auto">
				<trustifi-table-c
					#addRecipientsTableEl
					class="trustifi-table f-1-0" style="z-index: 5;"
					[list]="addCampaignRecipientsPopup.allPossibleRecipients"
					[headers]="[
						{text:'Name', sortKey: 'name'},
						{text:'Email', sortKey: 'email'},
					]"
					[cellsPrototype]="[
					  {html: 'nameCell'},
					  {textKey: 'email'},
					]"
					(searchFunction)="searchCampaignRecipients($event.searchTerm, $event.activeFilters)"
					[subRowOptions]="{
							recursionKey: 'members',
							allowActions: false
						}"
					[options]="{
						loadingTableFlag: addCampaignRecipientsPopup.loading,
						defaultSortKey: '-name',
						itemUniqueIdentifier: '_id',
						showRadioButtons: true,
					}"
				>
					<ng-template #customCells let-item let-cellId="cellId">
						<!--name cell-->
						<span *ngIf="cellId === 'nameCell'">
							<div class="flxRow hSpace05" style="align-items: center; cursor: pointer;"
								 (click)="toggleExpandItemCampaignRecipients(item, addRecipientsTableEl, $event);">
								<i class="far fa-chevron-right" style="color: royalblue; transition: transform 0.15s ease-out; padding: 5px;"
								   *ngIf="item.members?.length"
								   [ngStyle]="{'transform' : item.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}"></i>
								<span style="padding: 7px 0;" [ngClass]="{'text-primary' : item.alreadySent}"
									  [ngStyle]="{'margin-left' : item.members?.length || !item.depthLevel ? '' : '30px'}">
									{{item.name || item.email}} <b class="text-primary" *ngIf="item.alreadySent">(Sent)</b>
								</span>
							</div>
						</span>
					</ng-template>

					<div tableButtons>
						<div class="flex-row gap-2">
							<div class="flex-row align-items-center p-2 cursor-pointer hvr-opacity" style="border: solid 1px #cccccc; align-self: flex-end;"
								 (click)="addCampaignRecipientsPopup.showMailboxes = !addCampaignRecipientsPopup.showMailboxes; addRecipientsTableEl.searchItem();"
								 [ngClass]="{'color-text bg-primary' : addCampaignRecipientsPopup.showMailboxes}">
								<checkbox (click)="$event.preventDefault();"
										  [model]="addCampaignRecipientsPopup.showMailboxes">
									Show mailboxes
								</checkbox>
							</div>
							<div class="flex-row align-items-center p-2 cursor-pointer hvr-opacity" style="border: solid 1px #cccccc; align-self: flex-end;"
								 (click)="addCampaignRecipientsPopup.showGroups = !addCampaignRecipientsPopup.showGroups; addRecipientsTableEl.searchItem();"
								 [ngClass]="{'color-text bg-primary' : addCampaignRecipientsPopup.showGroups}">
								<checkbox (click)="$event.preventDefault();"
										  [model]="addCampaignRecipientsPopup.showGroups">
									Show groups
								</checkbox>
							</div>
						</div>
					</div>
				</trustifi-table-c>
				<div class="flex-row flex-wrap flex-shrink-0 overflow-auto justify-content-start gap-2 align-items-baseline" style="height: 62px; padding-left: 0.3rem; padding-right: 0.3rem;">
					<div *ngFor="let recipient of _.filter(addCampaignRecipientsPopup.allPossibleRecipients, 'selected'); trackBy: gs.trackByIndex"
						 class="p-1 d-flex hSpace05 align-items-center rounded-1 bg-dark"
						 (click)="recipient.selected = false; addRecipientsTableEl.searchItem();"
						 style="cursor: pointer; --bs-bg-opacity: .07; line-height: 16px;">
						<span [ngStyle]="{'font-weight' : !recipient.members?.length ? '' : '500'}">{{recipient.email}}</span>
						<span style="font-weight: 300; font-size: 12px;" *ngIf="recipient.members?.length"> (group)</span>
						<i class="zmdi zmdi-close"></i>
					</div>
				</div>
			</div>
		</div>
	</popup-c>
</div>
